import React from 'react'
import PropTypes from 'prop-types'


class CheckoutContinue extends React.Component {
  constructor(props) {
    super(props);
    this.onContinueClick = this.onContinueClick.bind(this);
  }

  onContinueClick() {
    this.props.onContinueClick(this.props.placeOrderDetails);
  }

  render() {
    return (
      <div className={`summary-complete-checkout text-center mb-5 ${this.props.additionalClassname && this.props.additionalClassname}`}>
        {!!!this.props.onPaymentScreen &&
            <button
              className='btn btn-red d-flex justify-content-between w-100'
              disabled={this.props.isPlaceOrderPending}
              onClick={(e) => this.onContinueClick(e)}
            >
              {this.props.continueButtonText}
            </button>
        }
      </div>
    );
  }
}

CheckoutContinue.propTypes = {
  continueButtonText: PropTypes.string.isRequired,
  placeOrderDetails: PropTypes.object.isRequired,
  additionalClassname: PropTypes.string,
  onContinueClick: PropTypes.func,
  onPaymentScreen: PropTypes.bool,
}

export default CheckoutContinue;
